export default __webpack_public_path__ + "static/media/MetricsIcon.792da2aa.svg";